import {UIActionTypes} from "./constants";

const updateAction = (payload: any) => {
    return {
        type: 'UPDATE',
        payload,
    };
};
export const updateVox = (payload: any) => {
    return {
        type: 'VOX_UPDATE',
        payload,
    };
};

export const updateRequest = (payload: any) => {
    return {
        type: 'UPDATE_REQUEST',
        payload,
    };
}

export const getChatRoom = (payload: any) => {
    return {
        type: UIActionTypes.CHATROOM,
        payload,
    };
}

export const getRequestAction = (payload: any) => {
    return {
        type: UIActionTypes.REQUEST,
        payload,
    };
}

export const clearRequest = (payload: any) => {
    return {
        type: UIActionTypes.CLEAR_REQUEST,
        payload,
    };
}

export const getAwaitingSupervisorOfferPackages = (payload: any) => {
    return {
        type: UIActionTypes.AWAITING_SUPERVISOR_OFFER_PACKAGES,
        payload,
    };
}

export default updateAction;
